module.exports = __webpack_public_path__ + "static/media/IMG_4874.de175a74.JPG";